import { dataBookBookmarkCheckSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookBookmarkCheckSolid = /*#__PURE__*/createIcon(dataBookBookmarkCheckSolid)
export default IconBookBookmarkCheckSolid
